import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchRollbackList } from '../../../rtk-apis/report/RollbackList'; // Import the async thunk

export interface RollbackListState {
  data: any[]; // Adjust type accordingly for your list data
  status:"";
  loading: boolean;
  error: string | null;
  total: number;
  message: string | null; // Store the message from the response
}

// Initial state for the slice
const initialState: RollbackListState = {
  data: [],
  status:"",
  loading: false,
  error: null,
  total: 0,
  message: null,
};

const rollbackSlice = createSlice({
  name: 'rollback',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Handle the different states of the async thunk (pending, fulfilled, rejected)
    builder
      .addCase(fetchRollbackList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRollbackList.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.status = action.payload.status;
        state.data = action.payload.result.list; // Set the list from the response
        state.total = action.payload.result.count || 0; // Assuming total is in the response
        state.message = action.payload.msg; // Set the message from the response
      })
      .addCase(fetchRollbackList.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// Export the reducer to be used in the store
export default rollbackSlice.reducer;
